import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from '../../apiSlice'
import { formDataCreate } from '../../../../utils/formDataUpload/formDataUpload'
import { IMessageAndStatusCode } from '../../admin/model'
import { IGetAllCourses, IGetCourseById, TCoursePayload } from './model'
import { ISearchParams } from '../../../../global.model'

export const coursesApis = createApi({
  reducerPath: 'courses/api',
  baseQuery: baseQueryWithReauth,
  endpoints: build => ({
    getAllCourses: build.query<IGetAllCourses, ISearchParams | void>({
      query: (params: ISearchParams) => ({ url: '/admin/courses', params })
    }),
    getCourseById: build.query<IGetCourseById, number>({
      query: (courseId: number) => `/admin/courses/${courseId}`
    }),
    createCourse: build.mutation<IMessageAndStatusCode, TCoursePayload>({
      query: courseData => ({
        url: '/admin/courses',
        method: 'POST',
        body: formDataCreate(courseData)
      })
    }),
    updateCourse: build.mutation<IMessageAndStatusCode, TCoursePayload>({
      query: courseData => ({
        url: `/admin/courses/${courseData.id}`,
        method: 'PUT',
        body: formDataCreate(courseData)
      })
    }),
    deleteCourseById: build.mutation<{ message: string }, string>({
      query: (courseId: string) => ({
        url: `/admin/courses/${courseId}`,
        method: 'DELETE'
      })
    })
  })
})
export const {
  useGetAllCoursesQuery,
  useGetCourseByIdQuery,
  useCreateCourseMutation,
  useUpdateCourseMutation,
  useDeleteCourseByIdMutation
} = coursesApis
